import { Component, OnInit, Pipe } from '@angular/core';
import { FloatLabelModule } from "primeng/floatlabel"
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { ChipsModule } from 'primeng/chips';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessagesService } from '../../../../../../shared/services/messages-service.service';
import { ToastService, serverErrorMessage } from '../../../../../../shared/services/toast.service';
import { constants } from '../../../../../../shared/constants/constants';
import { BulkMessageSummary, MessagePostData } from '../../message.interface';
import { ButtonModule } from 'primeng/button';
import { PipesModule } from '../../../../../../shared/pipes/pipes.module';
import { MessageComponentService } from '../../message.component.service';
import { UserService } from '../../../../../../shared/services/user.service';
import { UserClientVm } from '../../../../../../store/user/user.interface';
@Component({
  selector: 'app-create-discussion',
  templateUrl: './create-discussion.component.html',
  styleUrls: ['./create-discussion.component.scss'],
  standalone: true,
  imports:[
    PipesModule,
    FormsModule,
    FloatLabelModule,
    DropdownModule,
    ChipsModule,
    ButtonModule,
  ]
})
export class CreateDiscussionComponent implements OnInit {
  sendToHeading: string;
  data: any;
  messageTemplates: any;
  templateMessageSubject: any;
  templateMessageContent: any;
  user!: UserClientVm;
  
  constructor(private ref: DynamicDialogRef, public config: DynamicDialogConfig,
     private messagesService:MessagesService, private toastService:ToastService, private userService: UserService) { 
    this.data = config.data;
    this.sendToHeading = this.buildSendToHeading(config.data);
  }

  private buildSendToHeading(data: any): string {
    if (data.msgType === constants.messageType.reviewers) {
      const count = data.positionIds?.length ?? 0;
      const names = (data.recipientNames ?? []).join(', ');
      return `Send to ${count} candidate${count === 1 ? '' : 's'}: ${names}`;
    }
    return `Send to ${(data.msgType === 'REVIEWER' ? 'CANDIDATE' : data.msgType).toLowerCase()}: ${data.title}`;
  }

  ngOnInit(): void {
    this.user = this.userService.getSessionUser();
    this.getAllTemplate();
  }
  getAllTemplate(): void {
    this.messagesService.getAllMessageTemplates().subscribe(
      (res) => {
        this.messageTemplates = res;
      }
    );
  }

sendNewMessage(){
  if(this.data && this.data.formerlyAssigned && !this.data.isPresumptive) {
    this.toastService.showError('This candidate is no longer available  ');
    return;
  }

  if (this.templateMessageSubject && this.templateMessageContent) {
      let postData:MessagePostData = {
          type: this.data.msgType,
          id: this.data.projectId,
          subject: this.templateMessageSubject,
          message: this.templateMessageContent,
          senderId: this.user._id
      };
      if (this.data.status) {
          postData.status = this.data.status;
      }
      if (this.data.msgType === constants.messageType.role) {
          postData.id = this.data.roleId;
      }
      else if (this.data.msgType === constants.messageType.reviewer) {
          postData.id = this.data.reviewerId;
          postData.roleId = this.data.roleId;
          postData.projectId = this.data.projectId;
      }
      else if (this.data.msgType === constants.messageType.reviewers) {
          // MP-5692: backend ignores `id` and `senderId` for this type; the caller is the sender.
          postData.projectId = this.data.projectId;
          postData.positionIds = this.data.positionIds;
          delete postData.senderId;
          this.messagesService.sendMessage(postData).subscribe({
              next: (summary: BulkMessageSummary) => this.ref.close(summary),
              // MP-5694: a rejected batch (over the cap, not authorized, …) must say why and
              // leave the dialog open so the user can adjust and retry.
              error: (err: unknown) => this.toastService.showError(serverErrorMessage(err, 'Message could not be sent. Please try again'))
          });
          return;
      }
      this.messagesService.sendMessage(postData).subscribe(()=> {
          this.ref.close('success');
      });
  }
}

  onTemplateSelect(event:any){
     this.templateMessageSubject = event.value.subject;
     this.templateMessageContent = event.value.content;
  }

}
